import { SmartFilterChipColorType, SmartFilterChipSizeType } from '../types/smart-filter-chip.type';

/** Look of a selected chip per color; `transparent` stays outlined even when selected. */
export const SMART_FILTER_CHIP_COLORS_MAP: Record<SmartFilterChipColorType, string> = {
  transparent: '',
  white: 'tw:bg-gray-1 tw:hover:bg-white',
  gray: 'tw:bg-gray-3 tw:hover:bg-gray-2',
  primary: 'tw:bg-primary tw:hover:bg-primary-hover',
  orange: 'tw:bg-orange tw:hover:bg-orange-hover',
  green: 'tw:bg-green tw:hover:bg-green-hover',
  red: 'tw:bg-red tw:hover:bg-red-hover',
  purple: 'tw:bg-purple tw:hover:bg-purple-hover',
  yellow: 'tw:bg-yellow tw:hover:bg-yellow-hover',
};

export const SMART_FILTER_CHIP_SIZES_MAP: Record<SmartFilterChipSizeType, string> = {
  xs: 'tw:h-[30px]',
  small: 'tw:h-10',
};
